import React, { ReactElement } from "react";
import {
  TextField,
  Typography,
  Grid,
  FormControl,
  FormControlLabel,
  FormGroup,
  Checkbox,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { globalStyles } from "../../../assets/globalStyles";
import { useStyles } from "./anomalieStyle";
import {
  setAnteilTageTemp,
  selectAnteilTageTemp,
  setAnteilTageWertTemp,
  selectAnteilTageWertTemp,
  selectGroesserKleinerListe,
  selectAnomalieTemp,
  selectAnomalieWertTemp,
  setAnomalieTemp,
  setAnomalieWertTemp,
  selectAnomalietypTemp,
  addAnomalietypTemp,
  removeAnomalietypTemp,
  selectSignifikanzTemp,
  addSignifikanzTemp,
  removeSignifikanzTemp,
  setIsChangedAnomalie,
  setIsAnomaliewertAktiv,
  selectIsAnomaliewertAktiv,
} from "./anomalieFilterSlice";

function AnomalieFilter(): ReactElement {
  const dispatch = useAppDispatch();
  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };

  const groesserKleinerListe = useAppSelector(selectGroesserKleinerListe);
  const anteilTageTemp = useAppSelector(selectAnteilTageTemp);
  const anteilTageWertTemp = useAppSelector(selectAnteilTageWertTemp);
  const anomalieTemp = useAppSelector(selectAnomalieTemp);
  const anomalieWertTemp = useAppSelector(selectAnomalieWertTemp);
  const signifikanzTemp = useAppSelector(selectSignifikanzTemp);
  const anomalietypTemp = useAppSelector(selectAnomalietypTemp);
  const isAnomaliewertAktiv = useAppSelector(selectIsAnomaliewertAktiv);

  return (
    <div>
      <Grid item md={12} style={{ marginBottom: "20px" }} />
      <Grid item md={12} style={{ textAlign: "left", marginBottom: "20px" }}>
        <Typography color="primary">Anteil Tage (%)</Typography>
        <Grid container item md={12}>
          <Grid item md={6} style={{ paddingRight: "15px" }}>
            <Autocomplete
              id="select-anteilTage"
              value={anteilTageTemp}
              options={groesserKleinerListe}
              getOptionLabel={(option) => option}
              onChange={(event, nV) => {
                dispatch(setAnteilTageTemp(nV != null ? nV : ""));
                dispatch(setIsChangedAnomalie(true));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Größer/ Kleiner"
                  variant="outlined"
                  InputLabelProps={{ ...params.InputLabelProps }}
                  InputProps={{ ...params.InputProps }}
                />
              )}
              className={classes.selectEmpty}
            />
          </Grid>
          <Grid item md={6}>
            <FormControl className={classes.fullWidth}>
              <TextField
                id="anteilTage-einagbe"
                label="Eingabe Zahl"
                variant="outlined"
                type="number"
                inputProps={{
                  inputProps: {
                    min: 0,
                    max: 100,
                  },
                }}
                onChange={(event) => {
                  const inputValue = Number(
                    event.target.value.replace(/[^0-9]/g, "")
                  );
                  const input = inputValue > 100 ? 100 : inputValue;
                  dispatch(setAnteilTageWertTemp(input != null ? input : 0));
                  dispatch(setIsChangedAnomalie(true));
                }}
                value={anteilTageWertTemp}
                className={classes.selectEmpty}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Grid>

      <Grid item md={12} style={{ textAlign: "left", marginBottom: "20px" }}>
        <Typography color="primary">Signifikanz</Typography>
        <FormGroup row>
          <FormControlLabel
            style={{ marginRight: "30px" }}
            control={
              <Checkbox
                checked={
                  signifikanzTemp.find((e) => e == "niedrig") ? true : false
                }
                onChange={(e, nV) => {
                  nV
                    ? dispatch(addSignifikanzTemp("niedrig"))
                    : dispatch(removeSignifikanzTemp("niedrig"));
                  dispatch(setIsChangedAnomalie(true));
                }}
                name="niedrig"
              />
            }
            label="Niedrig"
          />
          <FormControlLabel
            style={{ marginRight: "30px" }}
            control={
              <Checkbox
                checked={
                  signifikanzTemp.find((e) => e == "mittel") ? true : false
                }
                onChange={(e, nV) => {
                  nV
                    ? dispatch(addSignifikanzTemp("mittel"))
                    : dispatch(removeSignifikanzTemp("mittel"));
                  dispatch(setIsChangedAnomalie(true));
                }}
                name="mittel"
              />
            }
            label="Mittel"
          />
          <FormControlLabel
            style={{ marginRight: "30px" }}
            control={
              <Checkbox
                checked={
                  signifikanzTemp.find((e) => e == "hoch") ? true : false
                }
                onChange={(e, nV) => {
                  nV
                    ? dispatch(addSignifikanzTemp("hoch"))
                    : dispatch(removeSignifikanzTemp("hoch"));
                  dispatch(setIsChangedAnomalie(true));
                }}
                name="hoch"
              />
            }
            label="Hoch"
          />
        </FormGroup>
      </Grid>
      <Grid item md={12} style={{ textAlign: "left", marginBottom: "20px" }}>
        <Typography color="primary">Anomalietyp</Typography>
        <FormGroup row>
          <FormControlLabel
            style={{ marginRight: "45px" }}
            control={
              <Checkbox
                checked={anomalietypTemp.find((e) => e == "c") ? true : false}
                onChange={(e, nV) => {
                  nV
                    ? dispatch(addAnomalietypTemp("c"))
                    : dispatch(removeAnomalietypTemp("c"));
                  dispatch(setIsChangedAnomalie(true));
                }}
                name="c"
              />
            }
            label="C"
          />
          <FormControlLabel
            style={{ marginRight: "45px" }}
            control={
              <Checkbox
                checked={anomalietypTemp.find((e) => e == "d") ? true : false}
                onChange={(e, nV) => {
                  nV
                    ? dispatch(addAnomalietypTemp("d"))
                    : dispatch(removeAnomalietypTemp("d"));
                  dispatch(setIsChangedAnomalie(true));
                }}
                name="d"
              />
            }
            label="D"
          />
          <FormControlLabel
            style={{ marginRight: "45px" }}
            control={
              <Checkbox
                checked={anomalietypTemp.find((e) => e == "e") ? true : false}
                onChange={(e, nV) => {
                  nV
                    ? dispatch(addAnomalietypTemp("e"))
                    : dispatch(removeAnomalietypTemp("e"));
                  dispatch(setIsChangedAnomalie(true));
                }}
                name="e"
              />
            }
            label="E"
          />
          <FormControlLabel
            style={{ marginRight: "45px" }}
            control={
              <Checkbox
                checked={anomalietypTemp.find((e) => e == "v") ? true : false}
                onChange={(e, nV) => {
                  nV
                    ? dispatch(addAnomalietypTemp("v"))
                    : dispatch(removeAnomalietypTemp("v"));
                  dispatch(setIsChangedAnomalie(true));
                }}
                name="v"
              />
            }
            label="V"
          />
        </FormGroup>
      </Grid>
      <Grid item md={12} style={{ textAlign: "left", marginBottom: "20px" }}>
        <Typography color="primary">Bewertung</Typography>
        <FormGroup row>
          <FormControlLabel
            style={{ marginRight: "30px" }}
            control={
              <Checkbox
                checked={isAnomaliewertAktiv}
                onChange={(e, nV) =>
                  nV
                    ? dispatch(setIsAnomaliewertAktiv(true))
                    : dispatch(setIsAnomaliewertAktiv(false))
                }
              />
            }
            label="Bewertung einschränken"
          />
        </FormGroup>
        {isAnomaliewertAktiv ? (
          <Grid container item md={12}>
            <Grid item md={6} style={{ paddingRight: "15px" }}>
              <Autocomplete
                id="select-anomalie"
                value={anomalieTemp}
                options={groesserKleinerListe}
                getOptionLabel={(option) => option}
                onChange={(event, nV) => {
                  dispatch(setAnomalieTemp(nV != null ? nV : ""));
                  dispatch(setIsChangedAnomalie(true));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Größer/ Kleiner"
                    variant="outlined"
                    InputLabelProps={{ ...params.InputLabelProps }}
                    InputProps={{ ...params.InputProps }}
                  />
                )}
                className={classes.selectEmpty}
              />
            </Grid>
            <Grid item md={6}>
              <FormControl className={classes.fullWidth}>
                <TextField
                  id="anomalie-eingabe"
                  label="Eingabe Zahl"
                  variant="outlined"
                  type="number"
                  inputProps={{
                    step: "0.01",
                    lang: "en-US",
                  }}
                  onChange={(event) => {
                    const inputValue = Number(
                      event.target.value.replace(/[^0-9.]/g, "")
                    );
                    dispatch(setAnomalieWertTemp(Number(inputValue)));
                    dispatch(setIsChangedAnomalie(true));
                  }}
                  value={anomalieWertTemp}
                  className={classes.selectEmpty}
                />
              </FormControl>
            </Grid>
          </Grid>
        ) : (
          ""
        )}
      </Grid>
    </div>
  );
}

export default AnomalieFilter;
